import React, { useState, useEffect } from "react";
import Slider3 from "../../../components/Booking/Slider3";
import LabourToggle from "../../../components/Booking/LabourToggle";
import TruckAndCrewWarningModal from "../../../components/Booking/TruckAndCrewWarningModal";
import TruckLabourMinimumWarningModal from "../../../components/Booking/TruckLabourMinimumWarningModal";
import QuoteQuestionsModal from "../../../components/Booking/QuoteQuestionsModal";

const VehicleScreen = ({
  isTruckRequired,
  vehicleTypesInfo,
  vehicleTypeId,
  handleUpdateBookingObject,
  labourNeeded,
  setIsNotATruckModalOpen,
  isNotATruckModalOpen,
  handleEstimatePrice,
  isTruckAndMooverWarningSeen,
  setIsTruckAndMooverWarningSeen,
}) => {
  // Modal state
  const [showTruckWarning, setShowTruckWarning] = useState(false);
  // Store pending labour change (increment/decrement)
  const [pendingLabourChange, setPendingLabourChange] = useState(null);
  const [isTruckLabourMinimumWarningSeen, setIsTruckLabourMinimumWarningSeen] =
    useState(false);
  const [showQuoteQuestionsModal, setShowQuoteQuestionsModal] = useState(false);
  const [hasQuoteQuestionsModalBeenShown, setHasQuoteQuestionsModalBeenShown] =
    useState(false);

  const handleLabourClick = (newLabour) => {
    // Agar modal already shown first time, skip modal next time
    if (!isTruckAndMooverWarningSeen) {
      setPendingLabourChange(newLabour);
      setShowTruckWarning(true);
      setIsTruckAndMooverWarningSeen(true); // mark that warning was shown
    } else {
      // normal behaviour without modal
      handleUpdateBookingObject("labourNeeded", newLabour, "labour-change");
      handleEstimatePrice();
    }
  };

  const handleConfirmLabourChange = () => {
    if (pendingLabourChange !== null) {
      handleUpdateBookingObject(
        "labourNeeded",
        pendingLabourChange,
        "labour-change",
      );
      handleEstimatePrice();
    }
    setPendingLabourChange(null);
    setShowTruckWarning(false);
  };

  const handleCancelLabourChange = () => {
    setPendingLabourChange(null);
    setShowTruckWarning(false);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (!hasQuoteQuestionsModalBeenShown) {
        setShowQuoteQuestionsModal(true);
        setHasQuoteQuestionsModalBeenShown(true);
      }
    }, 12000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      className="flex flex-col px-[33px] font-instrument justify-between h-full max-w-container"
      onClick={() => {
        if (!hasQuoteQuestionsModalBeenShown) {
          setShowQuoteQuestionsModal(true);
          setHasQuoteQuestionsModalBeenShown(true);
        }
      }}
    >
      <div>
        {/* Page title */}
        <p
          className="text-[#211F59] text-[24px] font-semibold font-instrument mb-[14.45px]"
          style={{ lineHeight: "23px" }}
        >
          Truck & crew
        </p>
        <p className="text-[#211F59] text-[16px] font-semibold font-instrument mt-[27px]">
          Recommended by AI
        </p>
        <p className="text-[#211F59] text-[12px] font-normal font-instrument mt-[11px]">
          Based on your items, here’s your estimated cost.
          <br />
          You’re billed hourly, so keep the crew as long as you need.
        </p>

        {isTruckRequired ? (
          <div onClick={(e) => e.stopPropagation()}>
            <Slider3
              vehicles={vehicleTypesInfo}
              vehicleTypeId={vehicleTypeId}
              handleUpdateBookingObject={handleUpdateBookingObject}
              handleEstimatePrice={handleEstimatePrice}
              isTruckAndMooverWarningSeen={isTruckAndMooverWarningSeen}
              setIsTruckAndMooverWarningSeen={setIsTruckAndMooverWarningSeen}
            />
          </div>
        ) : (
          <div
            className="h-[147px] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="bg-white w-[262.3px] h-[95.34px] rounded-[6.41px] mx-auto flex items-center justify-center"
              style={{
                boxShadow: "0px 3.20329px 3.20329px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div className="flex items-center gap-[18px]">
                <img
                  src="/images/NewUiIcons/MoverIcons.svg"
                  alt="icon"
                  className="w-auto h-auto"
                />
                <div className="flex flex-col font-instrument text-[#34318C]">
                  <p className="text-[16px] font-semibold">No truck selected</p>
                  <p>Labour only</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Numbers of movers */}
        <div
          className="flex justify-start #211F59 font-instrument"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="text-[16px] text-[#211F59] font-medium">
            {"Number of movers"}
          </p>
          <div className="flex items-center justify-between ml-[15px]">
            <div className="flex items-center">
              <button
                type="button"
                onClick={() => {
                  if (
                    (vehicleTypeId === 1004 || vehicleTypeId === 1005) &&
                    labourNeeded <= 2
                  ) {
                    setIsTruckLabourMinimumWarningSeen(true);
                    return;
                  }

                  // agar vehicle 1004 ya 1005 hai, minimum 2 enforce karo
                  if (vehicleTypeId === 1004 || vehicleTypeId === 1005) {
                    if (labourNeeded > 2) handleLabourClick(labourNeeded - 1);
                  } else {
                    if (labourNeeded > 1) handleLabourClick(labourNeeded - 1);
                  }
                }}
                aria-label="decrement"
              >
                <img
                  src="/images/NewUiIcons/Subtract Icon.svg"
                  alt="decrement"
                  className="w-[17px]"
                />
              </button>

              <div
                className="mx-1 w-6 text-center text-[16px] font-medium text-[#7876A1] tabular-nums"
                aria-live="polite"
              >
                {labourNeeded}
              </div>

              <button
                type="button"
                onClick={() => {
                  if (labourNeeded < 6) handleLabourClick(labourNeeded + 1);
                }}
                aria-label="increment"
              >
                <img
                  src="/images/NewUiIcons/Add Icon.svg"
                  alt="increment"
                  className="w-[17px]"
                />
              </button>
            </div>
          </div>
        </div>
        <hr className="h-[1px] bg-[#CDCCD7] mt-[11.12px]" />
      </div>

      {/* Labour toggle */}
      <div
        className="self-justify-end mb-2"
        onClick={(e) => e.stopPropagation()}
      >
        <LabourToggle
          setIsNotATruckModalOpen={setIsNotATruckModalOpen}
          isNotATruckModalOpen={isNotATruckModalOpen}
          handleUpdateBookingObject={handleUpdateBookingObject}
          tripStatus={"vehicle"}
          handleEstimatePrice={handleEstimatePrice}
        />
      </div>

      {/* Truck & crew warning modal */}
      <TruckAndCrewWarningModal
        open={showTruckWarning}
        onClose={handleCancelLabourChange}
        onConfirm={handleConfirmLabourChange}
      />

      <TruckLabourMinimumWarningModal
        isOpen={isTruckLabourMinimumWarningSeen}
        onClose={() => setIsTruckLabourMinimumWarningSeen(false)}
      />

      <QuoteQuestionsModal
        isOpen={showQuoteQuestionsModal}
        onClose={() => setShowQuoteQuestionsModal(false)}
      />
    </div>
  );
};

export default VehicleScreen;
